module.exports = __webpack_public_path__ + "static/pepsi_Page_4-1a7d55b519bbaea57012d97712009cf1.jpg";